import {
    CREATE_DISCOUNT_SUCCESS,
    DELETE_DISCOUNT_SUCCESS,
    DISCOUNTS_LIST_FILTER_UPDATE,
    DISCOUNTS_LIST_FILTER_CATEGORY,
    DISCOUNTS_LIST_PAGE,
    DISCOUNTS_LIST_SORT,
    FETCH_DISCOUNT,
    FETCH_DISCOUNTS,
    FETCH_DISCOUNT_FAILURE,
    FETCH_DISCOUNT_SUCCESS,
    FETCH_DISCOUNTS_FAILURE,
    FETCH_DISCOUNTS_SUCCESS,
    UPDATE_DISCOUNT,
    UPDATE_DISCOUNT_FAILURE,
    UPDATE_DISCOUNT_SUCCESS,
    SORT_ASC,
} from 'store/actions/types';
import paginationHelper from 'helpers/pagination';
import reducerHelper from 'helpers/reducers';
import utils from 'helpers/utils';

const initialState = {
    data: {},
    field: 'created_at',
    filter: {},
    filterCategory: reducerHelper.FILTER_BASIC,
    ids: [],
    loading: false,
    offset: 0,
    order: SORT_ASC,
    page: 1,
    size: 12,
    total: 0,
};

export default function (state = initialState, action) {
    switch (action.type) {
        case FETCH_DISCOUNT:
        case FETCH_DISCOUNTS:
        case UPDATE_DISCOUNT:
            return Object.assign({}, state, {
                loading: true,
            });

        case FETCH_DISCOUNT_FAILURE:
        case FETCH_DISCOUNTS_FAILURE:
        case UPDATE_DISCOUNT_FAILURE:
            return Object.assign({}, state, {
                loading: false,
            });

        case FETCH_DISCOUNT_SUCCESS:
            return Object.assign({}, state, {
                data: Object.assign({}, state.data, {
                    [action.response.id]: action.response,
                }),
                ids: [
                    ...state.ids,
                    ...action.response.id,
                ],
                loading: false,
            });

        case FETCH_DISCOUNTS_SUCCESS:
            // Converts the Array of results to an Object based on the id.
            const convertResultsToData = utils.mapToObject(action.payload.results, (value) => {
                return value.id;
            });

            const newIds = action.payload.results.map(function (result) {
                return result.id;
            });

            return Object.assign({}, state, {
                data: Object.assign({}, state.data, convertResultsToData),
                ids: newIds,
                loading: false,
                offset: action.payload.offset,
                size: action.payload.size,
                total: parseInt(action.payload.total, 10),
            });

        case CREATE_DISCOUNT_SUCCESS:
            return Object.assign({}, state, {
                data: Object.assign({}, state.data, {
                    [action.id]: action.response,
                }),
                loading: false,
            });

        case DELETE_DISCOUNT_SUCCESS:
            const {
                id,
            } = action.payload;

            const deletedData = reducerHelper.removeItemFromObject(state.data, id);
            const deletedStateIds = reducerHelper.removeItemFromArrayOfStrings(state.ids, id);

            return Object.assign({}, state, {
                data: deletedData,
                ids: deletedStateIds,
                loading: false,
                total: state.total - 1,
            });

        case UPDATE_DISCOUNT_SUCCESS:
            return Object.assign({}, state, {
                data: Object.assign({}, state.data, {
                    [action.payload.id]: action.response,
                }),
                loading: false,
            });

        case DISCOUNTS_LIST_FILTER_CATEGORY:
            return Object.assign({}, state, {
                filterCategory: action.payload,
            });

        case DISCOUNTS_LIST_PAGE:
            return Object.assign({}, state, {
                offset: paginationHelper.generateNewOffset(action.payload.page, state.size),
                page: action.payload.page,
            });

        case DISCOUNTS_LIST_SORT:
            return Object.assign({}, state, {
                field: action.payload.field,
                order: action.payload.order,
            });

        case DISCOUNTS_LIST_FILTER_UPDATE:
            const filteredValues = reducerHelper.normaliseState(initialState, action.payload);

            return Object.assign({}, state, filteredValues);

        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/store/reducers/discountsReducer.js